import { ApiPaths } from './ApiPaths';
import BaseApi from './BaseApi'

const create = () => {

    const api = BaseApi.create({ timeout: 120000 });

    const getAuthorizeConfig = (province) => api.get(ApiPaths.GET_AUTHORIZE_CONFIG(province));

    const loadAuthState = () => api.get(ApiPaths.AUTHORIZE_BLOCK);

    const saveAuthState = (authState) => api.post(ApiPaths.AUTHORIZE_BLOCK, authState);

    // Return back a collection of functions
    return {
        getAuthorizeConfig, loadAuthState, saveAuthState
    }
}

// let's return back our create method as the default.
export default {
    create
}